module.exports = __webpack_public_path__ + "static/platinum-047739032caea8af5be935ebe9cfa12a.png";